/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const QuotaPeriod = {
  Day: "day",
  Month: "month",
} as const;
export type QuotaPeriod = ClosedEnum<typeof QuotaPeriod>;

export type UpdateOrgQuotaRequestBody = {
  quotaEnabled?: boolean | undefined;
  quotaPeriod?: QuotaPeriod | undefined;
  quotaMax?: number | undefined;
};

export type UpdateOrgQuotaRequest = {
  orgId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody?: UpdateOrgQuotaRequestBody | undefined;
};

export const UpdateOrgQuotaQuotaPeriod = {
  Day: "day",
  Month: "month",
} as const;
export type UpdateOrgQuotaQuotaPeriod = ClosedEnum<
  typeof UpdateOrgQuotaQuotaPeriod
>;

/**
 * OK
 */
export type UpdateOrgQuotaResponseBody = {
  id: string;
  quotaEnabled: boolean;
  quotaPeriod: UpdateOrgQuotaQuotaPeriod | null;
  quotaMax: number | null;
};

/** @internal */
export const QuotaPeriod$inboundSchema: z.ZodNativeEnum<typeof QuotaPeriod> = z
  .nativeEnum(QuotaPeriod);
/** @internal */
export const QuotaPeriod$outboundSchema: z.ZodNativeEnum<typeof QuotaPeriod> =
  QuotaPeriod$inboundSchema;

/** @internal */
export const UpdateOrgQuotaRequestBody$inboundSchema: z.ZodType<
  UpdateOrgQuotaRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  quotaEnabled: z.boolean().optional(),
  quotaPeriod: QuotaPeriod$inboundSchema.optional(),
  quotaMax: z.number().int().optional(),
});
/** @internal */
export type UpdateOrgQuotaRequestBody$Outbound = {
  quotaEnabled?: boolean | undefined;
  quotaPeriod?: string | undefined;
  quotaMax?: number | undefined;
};

/** @internal */
export const UpdateOrgQuotaRequestBody$outboundSchema: z.ZodType<
  UpdateOrgQuotaRequestBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgQuotaRequestBody
> = z.object({
  quotaEnabled: z.boolean().optional(),
  quotaPeriod: QuotaPeriod$outboundSchema.optional(),
  quotaMax: z.number().int().optional(),
});

export function updateOrgQuotaRequestBodyToJSON(
  updateOrgQuotaRequestBody: UpdateOrgQuotaRequestBody,
): string {
  return JSON.stringify(
    UpdateOrgQuotaRequestBody$outboundSchema.parse(updateOrgQuotaRequestBody),
  );
}
export function updateOrgQuotaRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdateOrgQuotaRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateOrgQuotaRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateOrgQuotaRequestBody' from JSON`,
  );
}

/** @internal */
export const UpdateOrgQuotaRequest$inboundSchema: z.ZodType<
  UpdateOrgQuotaRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => UpdateOrgQuotaRequestBody$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type UpdateOrgQuotaRequest$Outbound = {
  orgId: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody?: UpdateOrgQuotaRequestBody$Outbound | undefined;
};

/** @internal */
export const UpdateOrgQuotaRequest$outboundSchema: z.ZodType<
  UpdateOrgQuotaRequest$Outbound,
  z.ZodTypeDef,
  UpdateOrgQuotaRequest
> = z.object({
  orgId: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => UpdateOrgQuotaRequestBody$outboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function updateOrgQuotaRequestToJSON(
  updateOrgQuotaRequest: UpdateOrgQuotaRequest,
): string {
  return JSON.stringify(
    UpdateOrgQuotaRequest$outboundSchema.parse(updateOrgQuotaRequest),
  );
}
export function updateOrgQuotaRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateOrgQuotaRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateOrgQuotaRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateOrgQuotaRequest' from JSON`,
  );
}

/** @internal */
export const UpdateOrgQuotaQuotaPeriod$inboundSchema: z.ZodNativeEnum<
  typeof UpdateOrgQuotaQuotaPeriod
> = z.nativeEnum(UpdateOrgQuotaQuotaPeriod);
/** @internal */
export const UpdateOrgQuotaQuotaPeriod$outboundSchema: z.ZodNativeEnum<
  typeof UpdateOrgQuotaQuotaPeriod
> = UpdateOrgQuotaQuotaPeriod$inboundSchema;

/** @internal */
export const UpdateOrgQuotaResponseBody$inboundSchema: z.ZodType<
  UpdateOrgQuotaResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  quotaEnabled: z.boolean(),
  quotaPeriod: z.nullable(UpdateOrgQuotaQuotaPeriod$inboundSchema),
  quotaMax: z.nullable(z.number()),
});
/** @internal */
export type UpdateOrgQuotaResponseBody$Outbound = {
  id: string;
  quotaEnabled: boolean;
  quotaPeriod: string | null;
  quotaMax: number | null;
};

/** @internal */
export const UpdateOrgQuotaResponseBody$outboundSchema: z.ZodType<
  UpdateOrgQuotaResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgQuotaResponseBody
> = z.object({
  id: z.string(),
  quotaEnabled: z.boolean(),
  quotaPeriod: z.nullable(UpdateOrgQuotaQuotaPeriod$outboundSchema),
  quotaMax: z.nullable(z.number()),
});

export function updateOrgQuotaResponseBodyToJSON(
  updateOrgQuotaResponseBody: UpdateOrgQuotaResponseBody,
): string {
  return JSON.stringify(
    UpdateOrgQuotaResponseBody$outboundSchema.parse(updateOrgQuotaResponseBody),
  );
}
export function updateOrgQuotaResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdateOrgQuotaResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateOrgQuotaResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateOrgQuotaResponseBody' from JSON`,
  );
}
